import {useCallback, useMemo} from "react";
import {
	DateField,
	SelectField
} from "~/components/Forms";
import {strToTime} from "~/utils";
import {useCan} from "~/hooks";

function WebsiteReportSearch({filter, listGroup, onChange}) {

	const groupOptions = useMemo(() => {
		return [{ value: '', label: 'Tất cả các nhóm' }, ...Object.entries(listGroup).map(([key, item]) => {
			return {value : item.id, label : item.name};
		})];
	}, [listGroup]);

	const typeOptions = [
		{value: 0, label: 'Không tính 500k demo'},
		{value: 1, label: 'Tính 500k demo'},
	];

	const handleTimeChange = useCallback((value) => {
		value = strToTime(value);
		if(onChange) onChange('time', value);
	}, [onChange]);

	const handleGroupChange = useCallback((value) => {
		if(onChange) onChange('groupId', value);
	}, [onChange]);

	const handleTypeChange = useCallback((value) => {
		if(onChange) onChange('type', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<form className="form" autoComplete="off">
				<DateField name="time" picker="month" onChange={handleTimeChange}/>
				<SelectField defaultValue={filter.groupId} placeholder="Chọn nhóm" options={groupOptions} onChange={(value) => handleGroupChange(value)} />
				<SelectField defaultValue={filter.type} options={typeOptions} onChange={(value) => handleTypeChange(value)} />
			</form>
		</div>
	)
}

export default WebsiteReportSearch;